import type React from "react";
import { useId } from "react";

import type { IconComponent } from "@/components/Icon/Icon";
import type { ButtonProps } from "@/design-system/Button";
import { buttonVariants } from "@/design-system/Button";
import { FileInput } from "@/design-system/FileInput";

export type UploadFileButtonProps = Pick<ButtonProps, "variant" | "disabled" | "size"> &
  Pick<React.InputHTMLAttributes<HTMLInputElement>, "accept" | "onChange"> & {
    icon?: IconComponent;
    children: React.ReactNode;
    name?: string;
  };

export function UploadFileButton({
  children,
  icon,
  name,
  accept,
  onChange,
  disabled,
  ...buttonProps
}: UploadFileButtonProps): React.ReactNode {
  const id = useId();

  return (
    <>
      <label
        className={buttonVariants({
          variant: buttonProps.variant,
          size: buttonProps.size,
          type: "label",
        })}
        htmlFor={id}
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
      >
        {icon}
        {children}
      </label>
      <FileInput data-testid="upload-input" disabled={disabled} {...{ id, name, accept, onChange }} />
    </>
  );
}
